module.exports = __webpack_public_path__ + "static/media/XNS.c73b8846.svg";